import { OnInit, Component, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'da-newuser-confirm-popup',
    templateUrl: './da-newuser-confirm-popup.html'
})
export class DAConfirmPopup implements OnInit {
    showSplashPopup: boolean = false;
    constructor(private dialog: MatDialog,
    private translationService: PershingTranslationService) {
      this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
  }

  ngOnInit() {
    // to do
  }

  navigateBack() {
      // close the window.
  }
}
